import { usePaymentPresentationLocale } from '../lib/usePaymentPresentationLocale'
import React from 'react'
import { CreditCard, LoaderCircle, ShieldCheck } from 'lucide-react'

export default function MemberPrivanaPayCheckoutOpeningPage() {
  const { t, locale } = usePaymentPresentationLocale(false)
  return (
    <div className="mp-payment-opening" lang={locale}>
      <div className="mp-payment-opening__card" role="status" aria-live="polite">
        <div className="mp-payment-opening__icon" aria-hidden="true">
          <CreditCard size={30} />
        </div>
        <p className="mp-eyebrow">Privana Pay</p>
        <h1> {t("portalPresentation.member_opening_secure_checkout")} </h1>
        <p> {t("portalPresentation.member_please_wait_while_we_prepare_your_payment")} </p>
        <div className="mp-payment-opening__progress" aria-hidden="true">
          <LoaderCircle className="spin" size={20} /> {t("portalPresentation.member_connecting_to_secure_checkout")} </div>
        <div className="mp-payment-opening__secure">
          <ShieldCheck size={18} /> {t("portalPresentation.member_your_member_portal_tab_will_stay_open")} </div>
      </div>
    </div>
  )
}
